import { Card, CardContent } from "@/components/ui/card";
import { MapPin } from "lucide-react";

const ZoneIntervention = () => {
  const zones = [
    {
      ville: "Nantes Centre",
      quartiers: ["Centre-ville", "Bouffay", "Decré-Cathédrale", "Graslin", "Commerce"]
    },
    {
      ville: "Nantes Nord",
      quartiers: ["Bottière-Chénaie", "Doulon", "Petit Port", "Halvèque", "Eraudière"]
    },
    {
      ville: "Nantes Sud",
      quartiers: ["Nantes Sud", "Bellevue", "Saint-Jacques", "Pont du Cens", "Procé"]
    },
    {
      ville: "Nantes Ouest",
      quartiers: ["Breil-Barberie", "Zola", "Hauts Pavés", "Saint-Donatien", "Malakoff"]
    },
    {
      ville: "Métropole Nantaise",
      quartiers: ["Saint-Herblain", "Rezé", "Saint-Sébastien", "Vertou", "Orvault", "Carquefou"]
    },
    {
      ville: "Loire-Atlantique",
      quartiers: ["Ancenis", "Clisson", "Pornic", "Sainte-Pazanne", "Bouguenais"]
    }
  ];

  return (
    <section className="py-16 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Notre Zone{" "}
            <span className="bg-gradient-primary bg-clip-text text-transparent">
              d'Intervention
            </span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            EPP intervient dans toute la métropole nantaise et en Loire-Atlantique pour vos besoins en nettoyage professionnel
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {zones.map((zone, index) => (
            <Card key={index} className="hover:shadow-lg transition-all group">
              <CardContent className="pt-6">
                <div className="flex items-start gap-3 mb-4">
                  <div className="bg-primary/10 p-2 rounded-lg group-hover:bg-gradient-primary transition-all">
                    <MapPin className="h-5 w-5 text-primary group-hover:text-primary-foreground transition-colors" />
                  </div>
                  <h3 className="text-xl font-semibold group-hover:text-primary transition-colors">
                    {zone.ville}
                  </h3>
                </div>
                <ul className="space-y-1 text-muted-foreground text-sm">
                  {zone.quartiers.map((quartier, idx) => (
                    <li key={idx} className="flex items-center gap-2">
                      <span className="w-1 h-1 bg-primary rounded-full"></span>
                      {quartier}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Card className="max-w-3xl mx-auto bg-gradient-to-r from-primary/5 to-secondary/5">
            <CardContent className="pt-6">
              <p className="text-lg mb-4">
                <strong>Votre secteur n'est pas listé ?</strong>
              </p>
              <p className="text-muted-foreground">
                Contactez-nous ! Nous étudions toutes les demandes et pouvons intervenir sur d'autres zones de la Loire-Atlantique selon vos besoins.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ZoneIntervention;
